export const tryCatch = async <T>(
  cb: (...args: unknown[]) => Promise<T | null>,
): Promise<T | null> => {
  try {
    return await cb()
  } catch (error: unknown) {
    console.error(error)
    return null
  }
}
